// extracted by mini-css-extract-plugin
export var table = "_vx-0";